/* Seaweed Roastery theme */
(function () {
const LOGO_MARK = (window.SR && window.SR.logoMark) || '';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const COLOURS = {
  classic:['#EBC36A','#E0925A','#6F8F5A','#F2DD8C','#8B6444'], bulgogi:['#7A4E35','#EBC36A','#6F8F5A','#F2DD8C','#94623F'],
  jeyuk:['#B5553E','#EBC36A','#8DAE72','#F2DD8C','#A04A36'], tuna:['#D9B48C','#F4ECDC','#5E8150','#F2DD8C','#EBC36A'],
  kimchi:['#C9553F','#F0CB5A','#6F8F5A','#F2DD8C','#EBC36A'], chicken:['#CF9A55','#EBC36A','#9DBB7A','#F2DD8C','#DDAE6C'],
  salmon:['#EE9A74','#A9C68A','#8DAE72','#F4ECDC','#EBC36A'], tofu:['#EFE7D6','#6F8F5A','#E0925A','#7C6A45','#F2DD8C']
};
const TYPES = {classic:{kr:'재래김', tex:'url(#laver)'}, green:{kr:'파래김', tex:'url(#parae)'}, gimbap:{kr:'김밥김', tex:'url(#thick)'}};
/* ---------- illustrations (flat, soft, no outlines) ---------- */
const RICE = '#F7F3EA';
function grains(r, n, seed = 1) {
  let s = '', k = seed;
  for (let i = 0; i < n; i++) { k = (k * 9301 + 49297) % 233280; const a = k / 233280 * 6.283; k = (k * 9301 + 49297) % 233280; const d = Math.sqrt(k / 233280) * r;
    s += `<ellipse cx="${(Math.cos(a)*d).toFixed(1)}" cy="${(Math.sin(a)*d).toFixed(1)}" rx="2.6" ry="1.3" transform="rotate(${(i*47)%180} ${(Math.cos(a)*d).toFixed(1)} ${(Math.sin(a)*d).toFixed(1)})" fill="#E8E0CF"/>`; }
  return s;
}
function slice(c, seed) {
  return `<circle r="70" fill="url(#gimG)"/>
    <path d="M-54 -34A64 64 0 0 1 14 -66" stroke="#fff" stroke-opacity=".16" stroke-width="3" fill="none" stroke-linecap="round"/>
    <circle r="59" fill="${RICE}"/>${grains(56, 46, seed)}
    <circle r="59" fill="none" stroke="#141312" stroke-opacity=".05" stroke-width="5"/>
    <rect x="-7" y="-32" width="14" height="42" rx="4" fill="${c[1]}"/>
    <rect x="-36" y="-24" width="24" height="17" rx="4" fill="${c[0]}"/>
    <rect x="11" y="-20" width="23" height="15" rx="4" fill="${c[4]}"/>
    <rect x="-33" y="1" width="27" height="13" rx="4" fill="${c[3]}"/>
    <circle cx="19" cy="15" r="12" fill="${c[2]}"/>
    <rect x="-11" y="17" width="17" height="17" rx="4" fill="${c[0]}" opacity=".9"/>
    <g fill="#FFF7E2"><ellipse cx="-44" cy="-4" rx="2" ry="1"/><ellipse cx="40" cy="-34" rx="2" ry="1" transform="rotate(40 40 -34)"/><ellipse cx="34" cy="40" rx="2" ry="1"/></g>`;
}
const shadow = (cx, cy, rx) => `<ellipse cx="${cx}" cy="${cy}" rx="${rx}" ry="${rx*.12}" fill="#141312" opacity=".08"/>`;
function svgGimbap(f) {
  return `<svg viewBox="0 0 200 200" role="img" aria-hidden="true">
    ${shadow(96,178,70)}
    <g transform="translate(138 74) scale(.56)">${slice(f.c, 7)}</g>
    <g transform="translate(90 110)">${slice(f.c, 3)}</g>
  </svg>`;
}
function svgChungmu(f) {
  const c = f.c;
  const roll = (x, y, a) => `<g transform="translate(${x} ${y}) rotate(${a})">
    <rect x="-46" y="-15" width="92" height="30" rx="15" fill="url(#gimG)"/>
    <rect x="-36" y="-10" width="56" height="3" rx="1.5" fill="#fff" opacity=".14"/>
    <ellipse cx="44" cy="0" rx="9" ry="14" fill="${RICE}"/><ellipse cx="45" cy="0" rx="4" ry="7" fill="#E8E0CF"/></g>`;
  return `<svg viewBox="0 0 200 200" role="img" aria-hidden="true">
    ${shadow(78,160,66)}${shadow(150,176,44)}
    ${roll(74,62,-14)}${roll(68,100,-8)}${roll(80,138,-16)}
    <ellipse cx="150" cy="156" rx="42" ry="26" fill="#E9DCC6"/>
    <ellipse cx="150" cy="152" rx="34" ry="18" fill="#DCC9AA"/>
    <rect x="128" y="140" width="22" height="16" rx="4" fill="${c[0]}" transform="rotate(-12 139 148)"/>
    <rect x="148" y="136" width="18" height="18" rx="4" fill="${c[4]}" transform="rotate(14 157 145)"/>
    <circle cx="164" cy="156" r="8" fill="${c[2]}"/>
    <rect x="140" y="154" width="16" height="10" rx="3" fill="${c[3]}"/>
    <line x1="176" y1="70" x2="148" y2="140" stroke="#B99467" stroke-width="3" stroke-linecap="round"/>
  </svg>`;
}
function svgCone() {
  const src = (window.SR && window.SR.coneArt) || '';
  return `<svg viewBox="0 0 200 200" role="img" aria-hidden="true">
    ${shadow(100,190,40)}
    <image href="${src}" x="56" y="6" width="88" height="188" preserveAspectRatio="xMidYMid meet"/>
  </svg>`;
}
function svgCup(f) {
  const c = f.c;
  return `<svg viewBox="0 0 200 200" role="img" aria-hidden="true">
    ${shadow(100,186,58)}
    <path d="M48 94 H152 L140 180 Q139 188 131 188 H69 Q61 188 60 180 Z" fill="url(#kraftG)"/>
    <image href="${LOGO_MARK}" x="85" y="126" width="30" height="28"/>
    <path d="M44 92 C52 38 148 38 156 92 Z" fill="${RICE}"/>
    <rect x="62" y="58" width="32" height="22" rx="5" fill="${c[0]}" transform="rotate(-10 78 69)"/>
    <circle cx="120" cy="58" r="13" fill="${c[2]}"/>
    <rect x="118" y="70" width="26" height="15" rx="4" fill="${c[1]}" transform="rotate(12 131 77)"/>
    <rect x="92" y="42" width="18" height="18" rx="4" fill="${c[4]}" transform="rotate(18 101 51)"/>
    <g fill="#1B1D1A"><rect x="80" y="46" width="11" height="4" rx="1" transform="rotate(-24 85 48)"/><rect x="108" y="78" width="10" height="4" rx="1" transform="rotate(30 113 80)"/><rect x="138" y="54" width="10" height="3" rx="1"/></g>
    <rect x="42" y="88" width="116" height="10" rx="5" fill="#CDB18A"/>
  </svg>`;
}
const DRAW = {gimbap:svgGimbap, chungmu:svgChungmu, cone:svgCone, taco:svgCone, cupbap:svgCup};

function svgPack(type, flavName, col) {
  const t = TYPES[type] || {kr:'김', tex:'url(#laver)'};
  const dark = (() => { const h = (col || '#E9DCC6').replace('#',''); const n = parseInt(h.length === 3 ? h.split('').map(x=>x+x).join('') : h, 16); const r=(n>>16)&255,g=(n>>8)&255,b=n&255; return (r*299+g*587+b*114)/1000 < 140; })();
  const label = (flavName || 'Plain').toUpperCase();
  const small = label.length > 12;
  return `<svg viewBox="0 0 160 200" role="img" aria-label="${esc(flavName || 'Gim')} pack">
    <ellipse cx="80" cy="192" rx="56" ry="5" fill="#141312" opacity=".08"/>
    <path d="M32 12 H128 Q136 12 136 20 L140 178 Q140 186 132 186 H28 Q20 186 20 178 L24 20 Q24 12 32 12Z" fill="#FFFFFF"/>
    <path d="M32 12 H128 Q136 12 136 20 L136.3 30 H23.7 L24 20 Q24 12 32 12Z" fill="#EEE7DA"/>
    <image href="${LOGO_MARK}" x="58" y="42" width="44" height="41"/>
    <text x="80" y="106" text-anchor="middle" font-family="Jost, sans-serif" font-size="8" letter-spacing="2.4" fill="#141312">SEAWEED ROASTERY</text>
    <text x="80" y="120" text-anchor="middle" font-family="Hahmlet, serif" font-weight="500" font-size="10" fill="#96703F">${t.kr}</text>
    <rect x="40" y="130" width="80" height="22" rx="4" fill="${t.tex}"/>
    <rect x="28" y="160" width="104" height="16" rx="8" fill="${col || '#E9DCC6'}"/>
    <text x="80" y="171.5" text-anchor="middle" font-family="Jost, sans-serif" font-weight="500" font-size="${small ? 6.4 : 7.5}" letter-spacing="${small ? .6 : 1.2}" fill="${dark ? '#FBFAF7' : '#141312'}">${esc(label)}</text>
  </svg>`;
}
const ICON = {
  grow:`<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M4 30q5-4 10 0t10 0 10 0 10 0" fill="none" stroke="#141312" stroke-width="1.8" stroke-linecap="round"/><path d="M4 38q5-4 10 0t10 0 10 0 10 0" fill="none" stroke="#141312" stroke-width="1.8" stroke-linecap="round" opacity=".4"/><path d="M10 8v22M38 8v22M10 12q14 6 28 0" fill="none" stroke="#141312" stroke-width="1.8" stroke-linecap="round"/><path d="M17 15v8M24 16v9M31 15v8" stroke="#6F8F5A" stroke-width="3" stroke-linecap="round"/></svg>`,
  press:`<svg viewBox="0 0 48 48" aria-hidden="true"><rect x="8" y="8" width="32" height="32" rx="2" fill="#DCC4A0"/><rect x="13" y="13" width="22" height="22" rx="1" fill="#1B1D1A"/><path d="M8 16h32M8 24h32M8 32h32" stroke="#96703F" stroke-width="1" opacity=".5"/></svg>`,
  brush:`<svg viewBox="0 0 48 48" aria-hidden="true"><rect x="6" y="22" width="30" height="20" rx="2" fill="#1B1D1A"/><path d="M10 28h18M10 34h14" stroke="#DCC4A0" stroke-width="2.4" stroke-linecap="round" opacity=".7"/><path d="M26 22l14-16" stroke="#96703F" stroke-width="3.4" stroke-linecap="round"/><path d="M22 26l6-6 3 3-6 6z" fill="#F7F3EA"/></svg>`,
  roast:`<svg viewBox="0 0 48 48" aria-hidden="true"><rect x="8" y="10" width="32" height="12" rx="2" fill="#1B1D1A"/><path d="M6 26h36" stroke="#141312" stroke-width="1.8" stroke-linecap="round"/><path d="M16 42c-4-4-2-8 0-10 1 3 3 3 3 1 0-3 2-5 4-6-1 4 3 6 3 10 0 3-2 5-5 5s-5 0-5 0z" fill="#C99A48"/><path d="M30 42c-3-3-2-6 0-8 1 2 3 2 3 0 2 2 3 4 3 6 0 1-1 2-3 2z" fill="#DCC4A0"/></svg>`,
  serve:`<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="17" fill="#1B1D1A"/><circle cx="24" cy="24" r="13" fill="#F7F3EA"/><rect x="22" y="15" width="4" height="11" rx="1.5" fill="#EBC36A"/><rect x="15" y="20" width="6" height="5" rx="1.5" fill="#E0925A"/><circle cx="28" cy="29" r="3.5" fill="#6F8F5A"/><rect x="17" y="27" width="7" height="4" rx="1.5" fill="#F2DD8C"/></svg>`
};

/* ---------- render illustrations ---------- */
function paint(root = document) {
  $$('[data-art]', root).forEach(el => {
    const draw = DRAW[el.dataset.art]; if (!draw) return;
    el.innerHTML = draw({ en: '', c: COLOURS[el.dataset.fill] || COLOURS.classic });
    if (el.classList.contains('ico')) { const s = el.querySelector('svg'); s.setAttribute('width', 54); s.setAttribute('height', 54); }
  });
  $$('[data-icon]', root).forEach(el => { el.innerHTML = ICON[el.dataset.icon] || ''; });
  $$('[data-pack]', root).forEach(el => { el.outerHTML = svgPack(el.dataset.pack, el.dataset.flav, el.dataset.colour); });
}

/* ---------- hero slides ---------- */
function slides() {
  const stage = $('[data-slides]'); if (!stage) return;
  const s = $$('.slide', stage), dots = $$('[data-dot]', stage); if (s.length < 2) return;
  let i = 0, t;
  const show = n => { i = (n + s.length) % s.length;
    s.forEach((x, k) => { const on = k === i; x.classList.toggle('on', on);
      const v = x.querySelector('video'); if (v) { if (on) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else { try { v.pause(); } catch (e) {} } } });
    dots.forEach((d, k) => d.setAttribute('aria-selected', k === i)); };
  const run = () => { clearInterval(t); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) t = setInterval(() => show(i + 1), 6000); };
  dots.forEach(d => d.addEventListener('click', () => { show(+d.dataset.dot); run(); }));
  run();
}

/* ---------- menu ---------- */
function menu() {
  const m = $('[data-menu]'); if (!m) return;
  $$('.base', m).forEach(btn => btn.addEventListener('click', () => {
    $$('.base', m).forEach(b => b.setAttribute('aria-pressed', b === btn));
    $$('.panel', m).forEach(p => p.hidden = p.dataset.panel !== btn.dataset.panel);
  }));
  const dlg = $('#dlg');
  $$('[data-dish]', m).forEach(btn => btn.addEventListener('click', () => {
    const tpl = btn.nextElementSibling; if (!tpl || !dlg) return;
    const art = btn.querySelector('.dish-art');
    dlg.innerHTML = `<div class="dlg" style="position:relative"><button class="x" type="button" data-close aria-label="Close">×</button><div class="art">${art ? art.innerHTML : ''}</div><div class="body"></div></div>`;
    dlg.querySelector('.body').appendChild(tpl.content.cloneNode(true));
    dlg.showModal();
  }));
  if (dlg) dlg.addEventListener('click', e => { if (e.target === dlg || e.target.closest('[data-close]')) dlg.close(); });
}

/* ---------- shop filters ---------- */
function shop() {
  const s = $('[data-shop]'); if (!s) return;
  let type = 'all', flav = 'all';
  const apply = () => {
    let shown = 0;
    $$('.prod', s).forEach(p => { const ok = (type === 'all' || p.dataset.type === type) && (flav === 'all' || p.dataset.flav === flav); p.classList.toggle('is-hidden', !ok); if (ok) shown++; });
    const empty = $('[data-empty]', s); if (empty) empty.hidden = shown > 0;
  };
  $$('[data-type]', s).forEach(b => { if (b.classList.contains('chip')) b.addEventListener('click', () => { type = b.dataset.type; $$('.chip[data-type]', s).forEach(x => x.setAttribute('aria-pressed', x === b)); apply(); }); });
  $$('.chip[data-flav]', s).forEach(b => b.addEventListener('click', () => { flav = b.dataset.flav; $$('.chip[data-flav]', s).forEach(x => x.setAttribute('aria-pressed', x === b)); apply(); }));
}

/* ---------- product variant price ---------- */
function pdp() {
  const sel = $('[data-variant-select]'); if (!sel) return;
  sel.addEventListener('change', () => { const o = sel.selectedOptions[0]; const p = $('[data-price]'); if (o && p) p.textContent = o.dataset.price; });
}

/* ---------- careers role preselect ---------- */
document.addEventListener('click', e => {
  const r = e.target.closest('[data-role]'); if (!r) return;
  const s = $('#j-role'); if (s) s.value = r.dataset.role;
});

function init() { paint(); slides(); menu(); shop(); pdp(); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', e => { paint(e.target); slides(); menu(); shop(); });
})();
